var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAltPlay = function SvgAltPlay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates---5.7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Love-Travels---New-Copy",
    transform: "translate(-277, -727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner-Layered-Desktop",
    transform: "translate(-22, 248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(181, 467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(118, 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0 C3.80557963,0 0,3.80557963 0,8.5 C0,13.1944204 3.80557963,17 8.5,17 C13.1944204,17 17,13.1944204 17,8.5 C17,3.80557963 13.1944204,0 8.5,0 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FF9962",
    points: "6 4 12.75 8.56468487 6 13"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAltPlay);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxN3B4IiBoZWlnaHQ9IjE3cHgiIHZpZXdCb3g9IjAgMCAxNyAxNyIgdmVyc2lvbj0iMS4xIj4KICA8dGl0bGU+UGxheTwvdGl0bGU+CiAgPGcgaWQ9IlVwZGF0ZXMtLS01LjciIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGcgaWQ9IkxvdmUtVHJhdmVscy0tLU5ldy1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjc3LCAtNzI3KSI+CiAgICAgIDxnIGlkPSJCYW5uZXItTGF5ZXJlZC1EZXNrdG9wIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIsIDI0OCkiPgogICAgICAgIDxnIGlkPSJHcm91cC0xNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTgxLCA0NjcpIj4KICAgICAgICAgIDxnIGlkPSJQbGF5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTgsIDEyKSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjUsMCBDMy44MDU1Nzk2MywwIDAsMy44MDU1Nzk2MyAwLDguNSBDMCwxMy4xOTQ0MjA0IDMuODA1NTc5NjMsMTcgOC41LDE3IEMxMy4xOTQ0MjA0LDE3IDE3LDEzLjE5NDQyMDQgMTcsOC41IEMxNywzLjgwNTU3OTYzIDEzLjE5NDQyMDQsMCA4LjUsMCBaIiBmaWxsPSIjMDAwMDAwIi8+CiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNGRjk5NjIiIHBvaW50cz0iNiA0IDEyLjc1IDguNTY0Njg0ODcgNiAxMyIvPgogICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";